/* eslint-disable react/no-unknown-property */
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import styles from './Login.module.scss';
import { Heading } from '../../ui/components/Heading/Heading';
import { Input } from '../../ui/components/Input/Input';
import { Button } from '../../ui/components/Button/Button';
import { REGEX_EMAIL_VALIDATION } from '../../utils/RegEx';
import { useGQLLazyQuery } from '../../ui/utils/graphql';
import { USER_LOGIN } from '../../graphql/user';

interface LoginForm {
  email: string;
  password: string;
}

interface LoginResponse {
  token: string;
  role: string;
}

export const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>();
  const navigate = useNavigate();
  const { lazy } = useGQLLazyQuery<LoginResponse, LoginForm>(USER_LOGIN, {
    onCompleted: (loginResponse) => {
      localStorage.setItem('token', loginResponse.token);
      navigate('/appointments');
      window.location.reload();
    },
  });

  const onSubmit = (data: LoginForm) => {
    lazy({
      variables: {
        email: data.email,
        password: data.password,
      },
    });
  };

  return (
    <div color-palette="scheduler-1" className={styles.root}>
      <div className={styles.container}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={styles['login-container']}
          action=""
        >
          <Heading headingLevel="h1">LOGIN</Heading>
          <Input
            label="Email"
            placeholder="Ejemplo: john@outlook.com"
            inputStyle="ultra-compressed"
            name="email"
            register={register('email', {
              pattern: {
                value: REGEX_EMAIL_VALIDATION,
                message: 'Should be a valid email',
              },
            })}
            errorMessage={errors?.email?.message}
          />
          <Input
            label="Contraseña"
            placeholder="Ingresa tu contraseña"
            inputStyle="ultra-compressed"
            type="password"
            register={register('password', {})}
          />
          <Button btnStyle="primary" type="submit" className={styles.login}>
            Iniciar sesión
          </Button>
        </form>
      </div>
    </div>
  );
};
